export enum FILTER_TYPE {
    LOKI = 'loki',
    SQL = 'sql',
}
